import React from 'react';
import {createPortal} from 'react-dom';
import styled from 'styled-components';

import Button from './Button';
import Overlay from './Overlay';
import {deviceLabel} from '../lib/zebraPrintUi';

/** Printer chooser shared by the single-row and bulk print flows. Portalled so it sits above side modals. */
function PrinterPickerDialog({
  title = 'Choose a printer',
  devices,
  selectedUid,
  onChange,
  onConfirm,
  onCancel,
  confirmLabel = 'Print',
  confirmDisabled = false,
  children
}) {
  return (
    <PrinterDialogFrame title={title} onDismiss={onCancel}>
      <PrinterSelect value={selectedUid || ''} onChange={e => onChange(e.target.value)}>
        {devices.map(device => (
          <option key={device.uid} value={device.uid}>{deviceLabel(device)}</option>
        ))}
      </PrinterSelect>
      {children}
      <DialogButtons>
        <Button type="button" disabled={confirmDisabled} onClick={onConfirm}>{confirmLabel}</Button>
        <Button secondary type="button" onClick={onCancel}>Cancel</Button>
      </DialogButtons>
    </PrinterDialogFrame>
  );
}

/** The dialog card without the printer select. Leave onDismiss unset to ignore overlay clicks. */
export function PrinterDialogFrame({title, onDismiss, children}) {
  return createPortal(
    <>
      <Overlay visible style={{zIndex: 40}} onClick={onDismiss} />
      <DialogCard role="dialog" aria-label={title}>
        <h4>{title}</h4>
        {children}
      </DialogCard>
    </>,
    document.body
  );
}

const DialogCard = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 41;
  width: 24rem;
  max-width: calc(100vw - 2rem);
  background: #ffffff;
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: 0 0.5rem 2rem rgba(4, 4, 15, 0.25);

  h4 {
    margin: 0 0 1rem 0;
    font-size: 1.125rem;
  }
`;

const PrinterSelect = styled.select`
  width: 100%;
  padding: 0.5rem;
  font-size: 1rem;
  border: 0.0625rem solid #d4d4d4;
  border-radius: 0.25rem;
  background: #ffffff;
`;

export const DialogButtons = styled.div`
  margin-top: 1.5rem;
  display: flex;
  gap: 0.75rem;
`;

export default PrinterPickerDialog;
